
import { Box } from "@mui/material";

import { TextareaAutosize } from "@mui/material";
import { useTheme } from "@emotion/react";

import { setupManagementUrl } from "../../../../config";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { allLeadStatus } from "../../../../data/Queries/SetupManagement/LeadStatusQueries";
import { LeadStatusColumns } from "../../../../data/Columns/leadstatusColumns";
import EmailTemplateForm from "./Form";

const base_url = setupManagementUrl.uri;
const actions = {
  entity: "Lead Status",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: true,
    permission: "ActivatePermission",
  },
  AssignTask: {
    key: "ASSIGN_TASK",
    button_name: "Assign Task",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2],
  },
};
function LeadStatuses() {
  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Lead Status"
          subtitle="Manage Lead Status"
          columns={LeadStatusColumns}
          FormComponent={EmailTemplateForm}
          query={allLeadStatus}
          base_url={base_url}
          actions={actions}
        />
      </>
    </Box>
  );
}

export default LeadStatuses;